<template>
  <div class="label">
    <CreateOrEditAdminInspectBusiness
      ref="createOrEditDialog"
      @submitDialog="GetTableList"
    />

    <div class="PageHeader">
      <el-breadcrumb>
        <el-breadcrumb-item>热处理</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="HeaderButtons">
        <el-button
          type="primary"
          icon="el-icon-plus"
          size="small"
          @click="CreateItem()"
          >{{l("新增")}}</el-button
        >
      </div>
    </div>
    <div class="PageContent">
      <el-row class="TableSearchRow" type="flex" :gutter="20">
        <el-col :span="4">
          <label>id</label>
          <el-input
            placeholder="请输入id"
            v-model="SearchData.id"
            clearable
            @clear="GetTableList(true)"
            @keyup.enter.native="GetTableList(true)"
          ></el-input>
        </el-col>
        <el-col :span="6">
          <label>{{l("标题")}}</label>
          <el-input
            :placeholder="l('请输入') + l('内容')"
            v-model="SearchData.name"
            clearable
            @clear="GetTableList(true)"
            @keyup.enter.native="GetTableList(true)"
          ></el-input>
        </el-col>

        <el-col :span="4">
          <el-checkbox
            v-model="SearchData.i18n"
            true-label="true"
            false-label="false"
            @change="GetTableList(true)"
            >英文版</el-checkbox
          >
        </el-col>

        <el-col :span="4">
          <el-button
            type="primary"
            icon="el-icon-search"
            round
            @click="GetTableList(true)"
            >{{l("查询")}}</el-button
          >
        </el-col>
      </el-row>
      <el-table
        :data="TableList"
        :stripe="true"
        @selection-change="HandleSelectionChange"
        @sort-change="HandleSortChange"
      >
        <TableOperation
          :operationList="[
            {
              is_show: (row) => true,
              label: '编辑',
              command: 'EditItem',
            },
            {
              is_show: (row) => true,
              label: '删除',
              command: 'DeleteItem',
            },
          ]"
          @handleOperation="HandleOperation"
        />

        <el-table-column prop="name" :label="l('名称')"></el-table-column>
        <el-table-column label="logo">
          <template slot-scope="scope">
            <div class="ImageInTable">
              <el-image
                :src="scope.row.logo"
                fit="contain"
                :preview-src-list="[scope.row.logo]"
              ></el-image>
            </div>
          </template>
        </el-table-column>

        <el-table-column :label="l('类型')">
          <template slot-scope="scope">
            <span v-if="scope.row.type == 1">{{l("企业")}}</span>
            <span v-else-if="scope.row.type == 2">{{l("个人")}}</span>
          </template>
        </el-table-column>

        <el-table-column label="英文版">
          <template slot-scope="scope">
            <span v-if="scope.row.i18n">
              <i class="el-icon-check color-success"></i>
            </span>
            <span v-else>
              <i class="el-icon-close color-danger"></i>
            </span>
          </template>
        </el-table-column>

        <el-table-column prop="order_index" label="优先级"></el-table-column>
        <el-table-column
          prop="address"
          label="地址"
          show-overflow-tooltip
        ></el-table-column>
      </el-table>
      <el-pagination
        background
        @size-change="HandleSizeChange"
        @current-change="HandleCurrentChange"
        :current-page="CurrentPage"
        :page-sizes="PageSizeList"
        :page-size="PageSize"
        layout="total, prev, pager, next, jumper"
        :total="TotalCount"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import tableMixin from "@/assets/js/tableMixin";
import CreateOrEditAdminInspectBusiness from "./operation/CreateOrEditAdminInspectBusiness.vue";

export default {
  name: "AdminInspectBusiness",
  components: {
    CreateOrEditAdminInspectBusiness,
  },
  mixins: [tableMixin],
  data() {
    return {
      SearchData: {
        id: null,
        name: "",
        i18n: false,
      },
    };
  },
  watch: {},
  mounted() {},
  methods: {
    GetTableList(resetPage) {
      if (resetPage == true) this.CurrentPage = 1;

      this.axios
        .get("/api/admin_inspect_business/", {
          params: {
            ...this.SearchData,
            ordering: this.Sorting,
            size: this.PageSize,
            page: this.CurrentPage,
          },
        })
        .then((data) => {
          this.TotalCount = data.count;
          this.TableList = data.results;
        });
    },
    DeleteItem(item) {
      console.log(item);
      this.$confirm(`是否删除${item.name}?`, "", {
        type: "warning",
      }).then(() => {
        this.axios
          .delete(`/api/admin_inspect_business/${item.id}/`)
          .then((response) => {
            this.GetTableList();
          });
      });
    },
  },
};
</script>


<style scoped lang="scss">
</style>

